import {Injectable} from "@angular/core";
import {Subject, Observable} from "rxjs";


@Injectable()
export class ThrobberService{
    private subject = new Subject<any>();

    setThrobberState(estado: boolean){
        this.subject.next({estado: estado});
    }

    getThrobber(): Observable<any>{
        return this.subject.asObservable();
    }
}